module.exports = __webpack_public_path__ + "static/img/section-chapter.82c2f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/course-detail/section-chapter.png
// module id = P08Y
// module chunks = 1